import { type PropsWithChildren } from 'react';
import { classNames } from '@utils/classNames.ts';

type HeadingProps = PropsWithChildren<React.HTMLProps<HTMLHeadingElement>>;

export function Heading5({ id, children, className, ...rest }: HeadingProps) {
  return (
    <h1
      id={id}
      className={classNames('text-base tracking-normal font-medium', className)}
      {...rest}
    >
      {children}
    </h1>
  );
}
